/**
 * エラーメッセージ
 */
export const FORM_INVALID = '入力内容にエラーがあります。確認して再度お試しください。'
export const AUTH_LOGIN_FAILED = 'メールアドレスまたはパスワードが違います。'
export const PASSWORD_RESET_FAILED = 'メールアドレスまたは確認コードが違います。'
export const CODE_MISMATCH = '確認コードが誤っています。'
export const CODE_EXPIRED = '確認コードの有効期限が切れています。再度、確認コードの発行をお願いします。'
export const USER_NOT_FOUND = '入力されたメールアドレスのアカウントが見つかりません。'
export const PASSWORD_NOT_FOUND = '$name$を正しく入力してください。'
export const PASSWORD_MISMATCH = 'パスワードが一致していません。'
export const PASSWORD_INVALID = '半角英小文字と数字を含めて、8文字以上で入力してください。'
export const PASSWORD_EXPIRED = '仮パスワードの有効期限が切れています。担当者までお問い合わせください。'
export const EMAIL_INVALID = '正しい形式のメールアドレスを入力してください。'
export const EMAIL_EXISTS = 'ご指定のメールアドレスは既に使用されています。'
export const EXCLUSIVE_CONTROL  = '一時的にデータを更新できませんでした。もう一度操作をやり直してください。'
export const INVALID_IMAGE_TYPE = 'jpg, png, gif形式の画像を選択してください。'
export const TOO_MUCH_UPLOAD = '1〜10個以内の画像を選択してください。'
export const URL_EXPIRED = 'リンクの有効期限が切れています。画面を再表示しますので、再度お試しください。'